import { gql, useQuery } from "@apollo/client"
import { COACH_TOOLS_API } from "../../apolloClient"

export const ORDERS_QUERY = gql`
  query GetOrders {
    currentPerson {
      orders {
        id
        balance
        orderType
        payable
        paymentStatus
        total
        totalPaid
        type
        status
        description
        createdAt
        staffCreated
        __typename
      }
    }
  }
`

export const withOrdersQuery = Component => props => {
  const { data } = useQuery(ORDERS_QUERY, {
    context: {
      api: COACH_TOOLS_API,
    },
  })
  const { currentPerson } = data || {}

  return <Component {...{ currentPerson, ...props }} />
}
